export default __webpack_public_path__ + "static/media/Track History.3553aedd.svg";